export default class t {
  constructor(t = !1, s = []) {
    (this.O = t), (this.ve = s), (this.O = t), (this.ve = s);
  }
  S(t) {
    (this.O = this.O && t.O), this.ve.push(...t.ve);
  }
}
